import { Typography } from "@mui/material";
import { styled, Theme } from "@mui/material/styles";

const commonLabel = (theme: Theme) => ({
    fontSize: "1.25rem",
    marginBottom: "1rem",
    fontWeight: 700,
    color: theme.palette.ink.soft,
});

// NG-8606: `StyledBoxWrapper` (the page's form measure) was replaced by PublicPageCard.
export const StyledOrgInfo = styled(Typography)(({ theme }) => ({
    marginTop: "1.2rem",
    ...commonLabel(theme),
}));

export const StyledAdminInfo = styled(Typography)(({ theme }) => ({
    marginTop: "1rem",
    ...commonLabel(theme),
}));
